import { interpolate, navigation } from '../services';
import { getStore } from '../store';
/**
 * 点击等行为处理器
 * @param {object} behavior - 行为信息
 */

export function behaviorHandle(behavior) {
  var route = behavior.route,
      action = behavior.action,
      actions = behavior.actions;

  if (route) {
    if (route === 'goBack') {
      navigation.goBack();
    } else {
      var entity = behavior.entity,
          params = behavior.params;
      navigation.goto(interpolate(route, {
        entity: entity,
        params: params
      }));
    }
  }

  if (action) {
    getStore().dispatch(action);
  }

  if (actions) {
    for (var _i = 0, actions_1 = actions; _i < actions_1.length; _i++) {
      var action_1 = actions_1[_i];
      getStore().dispatch(action_1);
    }
  }
}